// COLLECTIONS screen markup. Sections (Feast Days calendar / Relics / Apostles)
// are rendered by the controller (collections.ts) into #collectionsBody.
import { icon } from '../ui/icons';

export const collectionsHTML = /* html */ `
<div id="screenCollections" class="collections-screen hidden">
  <button class="btn secondary back" id="collectionsBackBtn" type="button" style="width:auto;padding:10px 16px;">← Home</button>
  <div class="content-head">
    <div class="content-title">${icon('cards')} Collections</div>
    <div class="content-sub" id="collectionsSub">Gather badges, relics & the Twelve Apostles</div>
  </div>
  <div id="collectionsNote" class="collections-note hidden"></div>
  <div id="collectionsBody" class="collections-body"></div>
</div>`;
